import { ChevronRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import type { ResumeItem } from "@/components/launch_pad/useLaunchPadDashboard";
import type { ActiveSection, LaunchPadNavigateOptions } from "@/types/appNavigation";

type LaunchPadRecentFeedProps = {
  items: ResumeItem[];
  onNavigate: (section: ActiveSection, options?: LaunchPadNavigateOptions) => void;
};

export function LaunchPadRecentFeed({ items, onNavigate }: LaunchPadRecentFeedProps) {
  if (items.length === 0) return null;

  return (
    <Card data-testid="launch-pad-recent-feed">
      <CardContent className="p-0">
        <ul>
          {items.map((item, index) => (
            <li key={item.id} className={index > 0 ? "border-t" : undefined}>
              <Button
                type="button"
                variant="ghost"
                className="h-auto w-full justify-between gap-3 rounded-none px-4 py-3 text-left font-normal hover:bg-muted/50"
                onClick={() => onNavigate(item.section, item.navigateOptions)}
              >
                <span className="min-w-0 flex-1">
                  <span className="block truncate font-medium">{item.title}</span>
                  <span className="mt-1 flex flex-wrap items-center gap-2">
                    <Badge variant="secondary" className="font-normal">
                      {item.moduleLabel}
                    </Badge>
                    <span className="text-xs text-muted-foreground">{item.relativeTime}</span>
                  </span>
                </span>
                <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
              </Button>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
